
import React from "react";

const SadIcon = ({ width, height, fill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || 50}
    height={height || 50}
    fill="none"
    viewBox="0 0 24 24"
  >
    <circle
      cx={12}
      cy={12}
      r={10}
      stroke={fill || "#1C274C"}
      strokeWidth={1.5}
    />
    <path
      stroke={fill || "#1C274C"}
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M9 17c.85-.63 1.885-1 3-1s2.15.37 3 1"
    />
    <ellipse cx={15} cy={10.5} fill={fill || "#1C274C"} rx={1} ry={1.5} />
    <ellipse cx={9} cy={10.5} fill={fill || "#1C274C"} rx={1} ry={1.5} />
  </svg>
);
export default SadIcon;
